import {
  Cart,
  EcomCart,
  Stores,
  ShoppingBag,
  Plus,
} from '@wix/wix-ui-icons-common/on-stage';

import { QUICK_ADD_ICON_TYPE } from '../../../../constants';

export const QUICK_ADD_ICON_TYPES = [
  { value: QUICK_ADD_ICON_TYPE.CART, Icon: Cart },
  { value: QUICK_ADD_ICON_TYPE.ECOM_CART, Icon: EcomCart },
  { value: QUICK_ADD_ICON_TYPE.STORES, Icon: Stores },
  { value: QUICK_ADD_ICON_TYPE.SHOPPING_BAG, Icon: ShoppingBag },
  { value: QUICK_ADD_ICON_TYPE.PLUS, Icon: Plus },
] as const;
